export default {
  MKR: 'MKR',
  WETH: 'WETH',
  PETH: 'PETH',
  ETH: 'ETH'
};
